// Constants

// URL for transaction verification 
export const ENERGI_TESTNET_EXPLORER = 'https://explorer.test.energi.network/tx/';
